import classnames from "classnames";
import * as React from "react";
import { useTranslation } from "react-i18next";
// tslint:disable-next-line:no-var-requires
const style = require("./CashoutDisclaimerButton.scss");

export interface CashoutDisclaimerButtonProps {
    readonly click?: () => void;
}

export default function CashoutDisclaimerButton({
    click
}: CashoutDisclaimerButtonProps) {
    const { t } = useTranslation("cashout");
    return (
        <div className={classnames(style.wrapper)}>
            <button
                className={classnames(style.disclaimerButton)}
                onClick={click}
            >
                {t("ShowDisclaimer")}
            </button>
        </div>
    );
}
